import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityLocalidadesState,
  entityLocalidadesAdapter
} from './entity-localidades.state';
import {
  entityLocalidadesLoadFailure,
  entityLocalidadesLoadRequest,
  entityLocalidadesLoadSuccess
} from './entity-localidades.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityLocalidadesLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityLocalidadesLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityLocalidadesLoadSuccess, (state, { items }) =>
    entityLocalidadesAdapter.setAll(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function localidadesReducer(
  state: EntityLocalidadesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
